// extracted by mini-css-extract-plugin
module.exports = {"row":"a10a3f92e9--row--LerJb","key":"a10a3f92e9--key--Sb38i","value":"a10a3f92e9--value--nzxPf","warning":"a10a3f92e9--warning--vPwaC"};